import Vue from "vue";
import VueRouter from "vue-router";
import {RouteConfig} from "vue-router/types/router";
import LangRouter from "vue-lang-router";
import translations from "../locales/translations";
// VueLangRouter conf translation file / route file and i18n Options
import store from "@/store";
import Rgpd from "../utils/rgpd";

//Vue.use(Meta);
Vue.use(LangRouter, {
  defaultLanguage: "fr",
  locale:"fr",
  translations,
  //localizedURLs,
  i18nOptions: {
    locale: process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    numberFormats: {
      fr: {
        percent: {
          style: "percent", useGrouping: false,
        },
        currency: {
          style: "currency", currency: "EUR", currencyDisplay: "symbol",
        },
        currencyNoCent: {
          style: "currency",
          minimumFractionDigits: 0, maximumFractionDigits: 0,
          currency: "EUR",
          currencyDisplay: "symbol",

        },
      },
    },
    dateTimeFormats: {
      fr: {
        short: {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        },
        long: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
      },
    },
  },
});

Vue.use(VueRouter);

const routes: RouteConfig[]= [
  {
    path: "/",
    name: "Home",
    component: () => import("@/pages/Home.vue"),
  },
  {
    path: "/categorie/:level1/:level2?/:level3?",
    name: "Category",
    component: () => import("@/pages/Category.vue"),
    beforeEnter: (to, from, next) => {
      function isValid(param) {
        // check if param is valid

        return true;
      }

      if (!isValid(to.params.level1)) {
        next({name: "Notfound"});
      }

      next();
    },
  },
  {
    path: "/produit/:productSlug",
    name: "Product",
    meta: {layout: "product"},
    component: () => import("@/pages/Product.vue"),

  },
  {
    path: "/reinitialisation-mot-de-passe",
    name: "ResetPassword",
    component: () => import("@/pages/ResetPassword.vue"),
  },
  {
    name: "My-account",
    path: "/mon-compte/:pageName?",
    component: () => import("@/pages/MyAccount.vue"),
  },
  {
    name: "Choose-couette",
    path: "/choisir-sa-couette",
    component: () => import("@/pages/ChooseCouette.vue"),
  },
  {
    name: "Choose-oreiller",
    path: "/choisir-son-oreiller",
    component: () => import("@/pages/ChooseOreiller.vue"),
  },
  {
    name: "Choose-Linge",
    path: "/choisir-son-linge-de-lit",
    component: () => import("@/pages/ChooseLinge.vue"),
  },
  {
    name: "Choose-Garnissage",
    path: "/choisir-son-garnissage",
    component: () => import("@/pages/ChooseGarnissage.vue"),
  },
  {
    name: "Choose-Surmatelas",
    path: "/choisir-son-surmatelas",
    component: () => import("@/pages/ChooseSurmatelas.vue"),
  },
  {
    path: "/maison-trinitas",
    redirect: "/maison-trinitas/ses-ambassadeurs"
  },
  {
    name: "Ambassadeurs",
    path: "/maison-trinitas/ses-ambassadeurs",
    component: () => import("@/pages/Ambassadeurs.vue"),
  },
  {
    name: "Valeurs",
    path: "/maison-trinitas/la-marque-et-ses-valeurs",
    component: () => import("@/pages/Valeurs.vue"),
  },
  {
    name: "Histoire",
    path: "/maison-trinitas/son-histoire-et-ses-hommes",
    component: () => import("@/pages/Histoire.vue"),
  },
  {
    name: "Savoir-Faire",
    path: "/maison-trinitas/son-savoir-faire",
    component: () => import("@/pages/SavoirFaire.vue"),
  },
  {
    name: "Professionals-Offer",
    path: "/offre-pour-professionnels",
    component: () => import("@/pages/ProfessionalsOffer.vue"),
  },
  {
    name: "References",
    path: "/nos-references",
    component: () => import("@/pages/References.vue"),
  },
  {
    name: "Checkout",
    path: "/commande/",
    meta: {layout: "checkout"},
    component: () => import("@/pages/Checkout.vue"),
    redirect: "/commande/livraison",

    children: [
      {
        path: "Connexion",
        name: "CheckoutLogin",
        meta: {layout: "checkout"},
        components: {checkout: () => import("@/pages/Checkout/Login.vue")},
      },
      {
        path: "livraison",
        name: "CheckoutShipping",
        meta: {layout: "checkout"},
        components: {checkout: () => import("@/pages/Checkout/Shipping.vue")},
        beforeEnter: requireAuthCheckout,
      },

      {
        path: "paiement",
        name: "CheckoutPayment",
        meta: {layout: "checkout"},
        components: {checkout: () => import("@/pages/Checkout/Payment.vue")},
        beforeEnter: requireAuthCheckout,
      },
    ],
  },
  {
    path: "/commande/paiement/resultat",
    name: "CheckoutPaymentResult",
    meta: {layout: "blank"},
    component: () => import("@/pages/Checkout/Payment-Result.vue"),
  },
  {
    path: "/commande/paiement/retour",
    name: "CheckoutPaymentReturn",
    meta: {layout: "blank"},
    component: () => import("@/pages/Checkout/Payment-Return.vue"),
  },
  {
    path: "/commande/merci/:order?",
    name: "CheckoutThankYou",
    component: () => import("@/pages/Checkout/ThankYou.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/pages/Contact.vue"),
  },
  {
    path: "/recherche",
    name: "Search",
    component: () => import("@/pages/Search.vue"),
  },
  {
    path: "/mon-panier",
    name: "Cart",
    component: () => import("@/pages/Cart.vue"),
  },
  {
    path: "/mentions-legales",
    name: "LegalMentions",
    component: () => import("@/pages/LegalMentions.vue"),
  },
  {
    path: "/qualite-trinitas",
    name: "Quality",
    component: () => import("@/pages/Quality.vue"),
  },
  {
    path: "/conditions-generales-de-vente",
    name: "TermsOfUse",
    component: () => import("@/pages/TermsOfUse.vue"),
  },
  {
    path: "/questions-frequentes",
    name: "Faq",
    component: () => import("@/pages/Faq.vue"),
  },
  {
    path: "/notre-concept",
    name: "WhoAreWe",
    component: () => import("@/pages/WhoAreWe.vue"),
  },
  {
    path: "/gestion-des-cookies",
    name: "Cookies",
    component: () => import("@/pages/Cookies.vue"),
  },
  {
    path: "/politique-de-protection-des-donnees-personnelles",
    name: "Rgpd",
    component: () => import("@/pages/Rgpd.vue"),
  },
  {
    path: "/livraison",
    name: "Livraison",
    component: () => import("@/pages/Delivery.vue"),
  },
  {
    path: "/echange-retour",
    name: "Echange et retour",
    component: () => import("@/pages/EchangeAndReturn.vue"),
  },
  {
    path: "/404",
    name: "Notfound",
    meta: {title: "not found", decription: {"content": "not found"}},
    component: () => import("@/pages/NotFound.vue"),
  },
  {
    path: "/401",
    name: "Notauthorized",
    component: () => import("@/pages/NotAuthorized.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new LangRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    //&& to.name != "category"
    Rgpd.initRgpd();
    if (to.name === from.name) {
      to.meta?.scrollPos && (to.meta.scrollPos.top = 0)
      if (to.hash) {
        return {
          behaviors: "smooth",
          selector: to.hash,
        };
      }else {
        return {left: 0, top: 0}
      }
    }
    if (savedPosition) {
      return savedPosition;
    }  else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  from.meta?.scrollPos && (from.meta.scrollPos.top = document.documentElement.scrollTop)
  return next()
})

function requireAuthCheckout(to, from, next) {

  function proceed() {
    if (store.getters.getProfile !== null) {
      if (store.getters.getProfile.customerGroup === "Empowerment") {
        router.push("/commande-empowerment").catch();
        return;
      }
      next();
    } else {
      if (from.name != "CheckoutLogin" && to.name != "CheckoutLogin") {
        router.push("/commande/connexion").catch();

        return;
      } else {
        if (to.name != "CheckoutLogin") {
          return;
        } else {
          next();
        }
      }
    }

    if (store.getters.getCart != null) {
      const cart = store.getters.getCart;
      if (cart && cart.cartItems.length > 0) {
        next();
      }
    } else {
      router.push("/mon-panier").catch();

    }
  }

  if (!store.getters.getProfile) {
    store.dispatch("getMe").then(proceed);
  }

  if (!store.getters.getCart) {
    store.dispatch("getCart").then(proceed);
  } else {
    proceed();
  }
}

export default router;
